@if (!loadingData) {
  <img
    #image
    [src]="imgUrl"
    [class]="class"
    [ngStyle]="style"
    [useMap]="useMap"
    (load)="loaded(image)"
    />
} @else {
  <div class="loading"></div>
}
